export default function calculateNom035MinimumRespondents(totalEmployees) {
  const total = Math.max(Number(totalEmployees) || 0, 0);
  if (total < 50) return total;
  return Math.ceil((0.9604 * total) / (0.0025 * (total - 1) + 0.9604));
}
